"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ImageAnnotations = _interopRequireDefault(require("../../Media/ImageAnnotations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const KioskAnnotateImageField = (_ref) => {
  let registry = _ref.registry,
      formContext = _ref.formContext,
      props = _objectWithoutPropertiesLoose(_ref, ["registry", "formContext"]);

  const _registry$formContext = registry.formContext,
        annotateImage = _registry$formContext.annotateImage,
        imageAnnotations = _registry$formContext.imageAnnotations,
        onAnnotateImageChange = _registry$formContext.onAnnotateImageChange;
  const mediaId = annotateImage.mediaId,
        media = annotateImage.media,
        imageFilters = annotateImage.imageFilters;
  return _react.default.createElement(_ImageAnnotations.default, {
    imageUrl: media.imageUrl,
    imageFilters: imageFilters,
    imageAnnotations: imageAnnotations,
    onChange: onAnnotateImageChange
  });
};

var _default = KioskAnnotateImageField;
exports.default = _default;
module.exports = exports.default;